import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMapPin, FiClock } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-800 via-gray-900 to-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h3 className="text-xl font-bold mb-4">Gateshead Halal Food Store</h3>
            <p className="text-gray-300 mb-4">
              Your trusted source for fresh halal meat, Asian groceries, and Mediterranean products in Gateshead.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiPhone} className="text-accent-400" />
                <span>+447460008191</span>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiMapPin} className="text-accent-400" />
                <span>Coastwood Road, Gateshead</span>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiClock} className="text-accent-400" />
                <span>Open Daily</span>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <h4 className="text-lg font-semibold mb-4">Our Specialties</h4>
            <ul className="text-gray-300 space-y-1">
              <li>Fresh Halal Meat</li>
              <li>Asian Groceries</li>
              <li>Mediterranean Products</li>
              <li>Lamb Shawarma</li>
              <li>Fresh Vegetables</li>
            </ul>
          </motion.div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-300 mb-2">
            © {currentYear} Gateshead Halal Food Store. All rights reserved.
          </p>
          <p className="text-gray-400 text-sm">
            Domain + Hosting + Design = <a href="https://www.account4web.ca" target="_blank" rel="noopener noreferrer" className="text-accent-400 hover:text-accent-300">Account4Web Inc</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;